"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class XHRClient {
    constructor(params) {
        this.initializationParams = params;
    }
    urlencode(str) {
        str = encodeURIComponent(str);
        str = str.replace(/\+/g, '%2B');
        str = str.replace('%20', '+');
        str = str.replace('*', '%2A');
        str = str.replace(/'/g, '%2F');
        str = str.replace('@', '%40');
        return str;
    }
    async sendRequest(page, request) {
        const requestString = JSON.stringify(request);
        const parameters = 'request=' + this.urlencode(requestString);
        const response = await axios_1.default
            .post(this.initializationParams.url + page, parameters, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/plain',
            },
            withCredentials: !page.toLowerCase().includes('requestqueuetoken'), // Send cookies when cross-domain requests
            proxy: false, // Disable default proxy behavior of Axios
            httpsAgent: this.initializationParams.httpsAgent,
        })
            .then((response) => response.data);
        return response;
    }
}
exports.default = XHRClient;
